import React, { Suspense, useEffect, useState } from 'react';
//FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fat } from '@fortawesome/pro-thin-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fass } from '@fortawesome/sharp-solid-svg-icons';
//Hook
import useAppHook from 'src/webapp/hooks/comn/app.hook';
import useSocketHook from './webapp/hooks/comn/socket.hook';
//Store
import usePartnerStore from './webapp/stores/partner.store';
//pages-init
import Routers from 'src/webapp/views/comn/Route';
import Spinner from './webapp/views/component/loading/Spinner';
//comp
import SubmitMessage from 'src/webapp/views/component/message/SubmitMessage';//결과메세지출력-공통

function App() {
  const { resizeHandler } = useAppHook();//윈도우사이즈변경
  const { ws, socketConnect, reserveSuccessButtonTrigger, reserveUpdateButtonTrigger, reserveSuccessSound, reserveUpdateSound } = useSocketHook();
  const { partner, isState } = usePartnerStore();

  useEffect(() => {
    resizeHandler();//윈도우리사이즈핸들러
    // library.add( fas, fat, fal, fasl, fass );//fontawesome
    library.add( fas, fat, fal, fass );//fontawesome
  }, []);
  // useEffect(() => {
  //   console.log(`%c
  //           ██████╗ ██╗   ██╗██████╗  █████╗ ██╗  ██╗██╗               
  //           ██╔══██╗██║   ██║██╔══██╗██╔══██╗██║ ██╔╝██║               
  //           ██║  ██║██║   ██║██████╔╝███████║█████╔╝ ██║               
  //           ██║  ██║██║   ██║██╔══██╗██╔══██║██╔═██╗ ██║               
  //           ██████╔╝╚██████╔╝██████╔╝██║  ██║██║  ██╗██║               
  //           ╚═════╝  ╚═════╝ ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝               
  //       Dubaki wishes our partners prosperity in the future
  //                 https://dubaki.co.kr/partners`                            
  //   , `color: #FFF; font-size: 12px; padding:0; font-family: monospace;`);
  // }, []);

  const [ isLock, setLock ] = useState(false);
  useEffect(() => {
    if(isState && !isLock) {
      setLock(true);
      socketConnect();//소켓연결
      setTimeout(()=> { setLock(true); }, 3000);
    }
  }, [ws, partner, isState]);
  
  return (
    <>
    <Suspense fallback={<Spinner />}><Routers /></Suspense>
    <button ref={reserveSuccessButtonTrigger} onClick={() => reserveSuccessSound.play()} style={{display:"none"}}></button>
    <button ref={reserveUpdateButtonTrigger} onClick={() => reserveUpdateSound.play()} style={{display:"none"}}></button>
    <SubmitMessage />
    </>
  );
}

export default App;